import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateChartWithCategoryV3 = OpalApi<'CreateChartWithCategoryV3', 201>

export const createChartWithCategory: CreateChartWithCategoryV3 = async (
  args = {}
) => {
  const url = new URL(
    `/loupe/v3/categories/${args.params?.path.category_id}/charts`,
    window.location.origin
  )

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
